import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getOrders, updateOrderStatus } from '../services/api';

const statusMap = {
  pending: 'معلق',
  confirmed: 'مؤكد',
  shipped: 'تم الشحن',
  delivered: 'تم التوصيل',
  cancelled: 'ملغي',
};

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchOrders = () => {
    getOrders()
      .then((data) => setOrders(data))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleStatusChange = async (orderId, newStatus) => {
    await updateOrderStatus(orderId, newStatus);
    fetchOrders();
  };

  if (loading) return <p className="text-center py-10 text-neutral-400">جار التحميل...</p>;

  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-3xl font-black text-white">الطلبات ({orders.length})</h2>
      </div>
      <div className="bg-neutral-950 rounded-xl border border-neutral-800 overflow-x-auto">
        <table className="w-full text-right">
          <thead className="bg-neutral-900 text-white">
            <tr>
              <th className="p-4">رقم الطلب</th>
              <th className="p-4">العميل</th>
              <th className="p-4">الهاتف</th>
              <th className="p-4">المجموع</th>
              <th className="p-4">الحالة</th>
              <th className="p-4">التاريخ</th>
              <th className="p-4">تفاصيل</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id} className="border-b border-neutral-800 hover:bg-neutral-900/50">
                <td className="p-4 font-bold text-white">#{order.id}</td>
                <td className="p-4 text-white">{order.customer_name}</td>
                <td className="p-4 text-neutral-300">{order.phone}</td>
                <td className="p-4 text-white">{order.total} شيكل</td>
                <td className="p-4">
                  <select
                    value={order.status}
                    onChange={(e) => handleStatusChange(order.id, e.target.value)}
                    className="bg-neutral-800 border border-neutral-700 rounded-lg px-2 py-1 text-sm text-white"
                  >
                    {Object.entries(statusMap).map(([val, label]) => (
                      <option key={val} value={val}>{label}</option>
                    ))}
                  </select>
                </td>
                <td className="p-4 text-neutral-400 text-sm">
                  {new Date(order.created_at).toLocaleDateString('ar-SA')}
                </td>
                <td className="p-4">
                  <Link
                    to={`/orders/${order.id}`}
                    className="bg-neutral-800 text-white px-3 py-1 rounded text-sm hover:bg-neutral-700"
                  >
                    عرض
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}